var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import NextLink from 'next/link';
import * as Styled from './LinkText.styled';
import capitalizeString from '../../util/capitalizeString';
var LinkText = function (_a) {
    var children = _a.children, href = _a.href, size = _a.size, _b = _a.variant, variant = _b === void 0 ? 'body' : _b, active = _a.active, onClick = _a.onClick, padding = _a.padding, underline = _a.underline, _c = _a.fancyAnimation, fancyAnimation = _c === void 0 ? true : _c, icon = _a.icon, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'right' : _d, color = _a.color, props = __rest(_a, ["children", "href", "size", "variant", "active", "onClick", "padding", "underline", "fancyAnimation", "icon", "iconPosition", "color"]);
    var capitalizeChildren = function () {
        if (children &&
            !React.isValidElement(children) &&
            typeof children === 'string') {
            return capitalizeString(children);
        }
        return children;
    };
    var isAnimated = fancyAnimation && !underline;
    return (React.createElement(Styled.StyledLink, __assign({ as: href ? NextLink : 'a', href: href, size: size, variant: variant, padding: padding, "$active": active, onClick: onClick, "data-label": "linkText", color: color, "$iconPosition": iconPosition, "$animated": isAnimated, "$animateIcon": !!icon && isAnimated }, props),
        React.createElement(Styled.StyledLinkContainer, null,
            icon && iconPosition === 'left' && (React.createElement(Styled.StyledIcon, { "$iconPosition": iconPosition, className: "icon-link" }, icon)),
            React.createElement(Styled.StyledSpan, { underline: underline }, capitalizeChildren()),
            icon && iconPosition === 'right' && (React.createElement(Styled.StyledIcon, { "$iconPosition": iconPosition, className: "icon-link" }, icon)))));
};
export default LinkText;
